module.exports = __webpack_public_path__ + "static/section-img3@2x-c693219f47f2ceae5d21f055ab42a89a.png";